import './App.css';
import ContactSection from './components/home/ContactSection';
import Navbar from './components/NavBar';

function AppLayout({ children }) {
  return (
    <div className="page">
      <Navbar/>
      <main className="page-content">
        {children}
      </main>
      <footer className="footer">
        <ContactSection/>
      </footer>
    </div>
  );
}

export default AppLayout;

